import { render, staticRenderFns } from "./20210115.vue?vue&type=template&id=2d785366&lang=pug&"
var script = {}
import style0 from "./20210115.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports